export default __webpack_public_path__ + "static/media/corporate_admin_upload.24732f78.svg";